import React, { useEffect, useRef } from 'react';

export function useInterval(callbackFunc, delay) {
    const savedCallback = useRef();
    // Remember The latest call Back.

    useEffect(() => {
        savedCallback.current = callbackFunc;
    }, [callbackFunc]);

    // Setup the Interval .
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            const identifier = setInterval(tick, delay);
            return () => {
                clearInterval(identifier);
            };
        }
    }, [callbackFunc, delay]);
}

export function useFilteredFields(baseList, isTerminalView, removeWhenTerminal = []) {
  return React.useMemo(() => {
    if (isTerminalView) {
      return baseList.filter((field) => !removeWhenTerminal.includes(field.name));
    }
    
    return baseList;
  }, [baseList, isTerminalView, removeWhenTerminal]);
}